import request from '@/utils/request'

// 查询配色物料关系列表
export function apiMaterialMatchColorPrepareConfigList (query) {
  return request({
    url: '/mdm/materialMatchColorPrepareConfig/list',
    method: 'get',
    params: query
  })
}

// 导出待配色关系列表V2
export function apiMaterialMatchColorPrepareConfigExport (data) {
  return request({
    url: '/mdm/materialMatchColorPrepareConfig/v2/export',
    method: 'post',
    data: data
  })
}

// 修改
export function apiMaterialMatchColorPrepareConfigEdit (data) {
  return request({
    url: '/mdm/materialMatchColorPrepareConfig',
    method: 'put',
    data: data
  })
}

// 刷新
export function apiRefreshMaterialColorRelation (query) {
  return request({
    url: '/mes/refreshMaterialColorRelation',
    method: 'get',
    params: query
  })
}
